import tacklebox from "tacklebox";

import { Page } from '@/js/Page.js';

import { History } from "../dto/History";

function Answer(id, title, description) {
    this.id = id;
    this.title = title;
    this.description = description;
}


function Qa(raw) {
    this.raw = raw;
}
Qa.prototype.getQuestionId = function () {
    if (this.raw?.qa) {
        return this.raw.qa?.id;
    }
    return "";
};
Qa.prototype.getQuestionTitle = function () {
    if (this.raw?.qa) {
        return this.raw.qa?.title;
    }
    return "";
};
Qa.prototype.getQuestionAllNumber = function () {
    if (this.raw?.qa) {
        return this.raw.qa?.allstep;
    }
    return "";
};
Qa.prototype.getQuestionNumber = function () {
    if (this.raw?.qa) {
        return this.raw.qa?.step;
    }
    return "";
};
Qa.prototype.getQuestionDescription = function () {
    if (this.raw?.qa) {
        return this.raw.qa?.description;
    }
    return "";
};
Qa.prototype.getAnswers = function () {
    if (this.raw?.qa?.answers) {
        let anws = [];
        for (let i in this.raw?.qa?.answers) {
            let ans = this.raw?.qa?.answers[i];
            anws.push(new Answer(
                ans.id,
                ans.title,
                ans.description
            ));
        }
        return anws;
    }

    return [];
};
Qa.prototype.isMultiSelect = function () {
    if (this.raw?.qa?.form) {
        if (this.raw.qa.form == "multi") {
            return true;
        }
    }
    return false;
};
Qa.prototype.getHistory = function () {
    let hs = [];

    for (let i in this.raw) {
        hs.push(
            new History(
                this.raw[i]
            )
        );
    }

    return hs;
};


function HistoryPage() {
    Page.call(this, "History", "回答履歴");
    this.interviewId = "";
    this.isProgress = false;
    this.qa = null;
    this.selectId = null;
}
tacklebox.design.extend(HistoryPage, Page);
HistoryPage.prototype._onInitialize = function () {
    this.loadQa();
};
HistoryPage.prototype.loadQa = function () {
    const self = this;
    this.qa = null;
    this.selecteds = [];
    this.isProgress = true;
    fetch(process.env.VUE_APP_HACHIWARE + "/interviews/" + this.interviewId + "/history", {
        headers: {
            'Content-Type': 'application/json'
        },
    })
        .then((response) => response.json())
        .then((json) => {
            self.qa = new Qa(json.data);
            if (json.data.qa == null) {
                if (self.callback) {
                    self.callback();
                }
            }
            this.isProgress = false;
        })
        .catch((error) => {
            tacklebox.e(error)
            this.isProgress = false;
        });
};
HistoryPage.prototype.select = function (id) {
    this.selectId = id;
};


export { HistoryPage }
